<template>
  <!-- 网点列表 -->
  <div class="page">
    <!-- 搜索区域 -->
    <div class="search" v-permission="['serviceStationList:search']">
      <el-form ref="form" :model="searchParams" label-width="auto" class="from">
        <el-form-item :label="$t('afterSales.text1')">
          <el-input
            clearable
            v-model="searchParams.serviceStationName"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('afterSales.text2')">
          <el-input
            clearable
            v-model="searchParams.principal"
            :placeholder="$t('public.text1')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('afterSales.text3')">
          <el-select
            clearable
            v-model="searchParams.serviceContent"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="item in option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('afterSales.text4')">
          <el-select
            clearable
            v-model="searchParams.status"
            :placeholder="$t('public.text5')"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="searchSubmit">
        <DiluButton type="search" @click="search"></DiluButton>
        <DiluButton type="reset" @click="reset"></DiluButton>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="operation" v-permission="['serviceStationList:add']">
      <DiluButton type="add" @click="add"></DiluButton>
    </div>

    <!-- 表格 -->
    <DiluTable
      :list="tableData"
      :tableConfig="tableConfig"
      :total="total"
      :pageSize="searchParams.pageSize"
      @currentChange="currentChange"
    >
      <el-table-column
        prop="serviceStationName"
        :label="$t('afterSales.text1')"
        width="200"
        align="left"
      >
      </el-table-column>
      <el-table-column
        prop="serviceContent"
        :label="$t('afterSales.text3')"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.serviceContent.length == 1"
            >{{
              scope.row.serviceContent[0] === 1
                ? $t("afterSales.text6")
                : $t("afterSales.text7")
            }}
          </span>
          <span v-else>
            {{ $t("afterSales.text6") }},{{ $t("afterSales.text7") }}</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('afterSales.text5')" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.serveStartTime + "-" + scope.row.serveStopTime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="principal"
        :label="$t('afterSales.text2')"
        align="center"
      >
      </el-table-column>
      <el-table-column :label="$t('afterSales.text4')" align="center">
        <template slot-scope="scope">
          <span
            >{{
              scope.row.status == 0
                ? $t("pages.operate.text4")
                : $t("pages.operate.text5")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        :label="$t('afterSales.text36')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        :label="$t('public.text4')"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="table-operation">
            <el-button
              @click="see(scope.row)"
              type="text"
              v-permission="['serviceStationList:see']"
            >
              {{ $t("button.look") }}
            </el-button>
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['serviceStationList:edit']"
              >{{ $t("button.edit") }}</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.status == 0"
              disabled
              v-permission="['serviceStationList:remove']"
              >{{ $t("button.delete") }}</el-button
            >
            <el-button
              @click="remove(scope.row)"
              type="text"
              v-else
              v-permission="['serviceStationList:remove']"
              >{{ $t("button.delete") }}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <AddOutlets
      @mapdialogVisibleCloe="mapdialogVisibleCloe"
      :mapDialogVisible="mapDialogVisible"
      @networkList="networkList"
      :isAdd="isAdd"
      :currentRole="currentRole"
    />
  </div>
</template>


<script>
import DiluButton from "../../../components/pubilc/dilu-button.vue";
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import { mapState } from "vuex";
import AddOutlets from "../../afterSales/serviceMgt/module/addOutlets.vue";
export default {
  data() {
    return {
      currentRole: {},
      option: [
        {
          value: 1,
          label: this.$t("afterSales.text6"),
        },
        {
          value: 2,
          label: this.$t("afterSales.text7"),
        },
      ],
      options: [
        {
          value: 0,
          label: this.$t("pages.operate.text4"),
        },
        {
          value: 1,
          label: this.$t("pages.operate.text5"),
        },
      ],
      isAdd: 1, //新增0，编辑1，查看3
      searchParams: {
        serviceStationName: "", //网点名称
        principal: "", //负责人
        serviceContent: null, //服务内容 1销售 2维保
        status: "", //状态 0启用 1禁用
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      }, // 搜索条件
      mapDialogVisible: false,
      tableConfig: {
        isTree: false,
        isPage: true,
      },
      tableData: [],
      total: 0,
      //地图
      /* isGoogle: false,
      center: { lat: 51.51108087472238, lng: -0.12420020719467573 },
      zoom: 2,
      map: null,
      addrValue: null,
      bermudaTriangle: null,
      infowindow: null,
      infowindowmarker: null, */
      isSerch: false, //是否在查询
    };
  },
  computed: {
    ...mapState(["platformData"]),
  },
  components: {
    DiluTable,
    DiluButton,
    AddOutlets,
  },
  mounted() {
    this.networkList();
  },
  methods: {
    //搜索
    search() {
      this.isSerch = true; //是否在查询
      this.searchParams.pageNum = 1;
      this.total = 0;
      this.networkList();
    },
    //重置
    reset() {
      this.isSerch = false; //是否在查询
      this.searchParams.pageNum = 1;
      this.searchParams.pageSize = 10;
      (this.searchParams = {
        serviceStationName: "", //网点名称
        principal: "", //负责人
        serviceContent: null, //服务内容 1销售 2维保
        status: null, //状态 0启用 1禁用
        pageNum: 1, //页码
        pageSize: 10, //每页条数
      }), // 搜索条件
        (this.total = 0);
      this.networkList();
    },
    //关闭弹窗
    mapdialogVisibleCloe() {
      this.mapDialogVisible = false;
    },
    //新增
    add() {
      this.isAdd = 1;
      this.mapDialogVisible = true;
    },
    //查看
    see(e) {
      this.isAdd = 3;
      this.currentRole = e;
      this.mapDialogVisible = true;
    },
    //编辑
    edit(e) {
      this.isAdd = 2;
      this.currentRole = e;
      this.mapDialogVisible = true;
    },

    //翻页
    currentChange(e) {
      if (!this.isSerch) {
        this.searchParams.pageNum = 1;
        this.searchParams.pageSize = 10;
      }
      this.searchParams.pageNum = e;
      this.networkList();
    },
    //删除
    remove(e) {
      this.$confirm(this.$t("afterSales.text8"), this.$t("public.text6"), {
        confirmButtonText: this.$t("button.determine"),
        cancelButtonText: this.$t("button.cancel"),
        type: "warning",
      })
        .then(() => {
          let str = "id=" + e.id;
          this.request.networkDelete(str).then(() => {
            this.$message.success(this.$t("public.text7"));
            this.networkList();
          });
        })
        .catch(() => {});
    },
    //查询列表
    networkList() {
      this.request.networkList(this.searchParams).then((res) => {
        this.tableData = res.data;
        this.total = res.dataMaxCount;
      });
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
.search {
  margin-bottom: 20px;
}
</style>